export const EMPTY_ELEMENT = {
  metric: '',
  stage: '',
  relativeToLastYear: 'Increase',
  enteringClassYear: new Date().getFullYear(),
  summary: '',
  note: '',
  details: [],
};
